(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["extract-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    }

    // "A-E" -> ['a', 'e'], "Q" -> ['q', 'q'], anything else -> null
    function parseRange(value) {
      var m = /^([a-z])(?:\s*-\s*([a-z]))?$/.exec(norm(value));
      return m ? [m[1], m[2] || m[1]] : null;
    }

    function init(root) {
      if (root.xfReady) return;
      root.xfReady = true;

      var list = root.querySelector('[data-xf-list]');
      var countEl = root.querySelector('[data-xf-count]');
      var emptyEl = root.querySelector('[data-xf-empty]');
      var searchEl = root.querySelector('[data-xf-search]');
      var buttons = root.querySelectorAll('[data-xf-filter]');
      var label = root.getAttribute('data-label') || 'items';

      var state = { range: '', type: '', q: '' };
      var items = [];
      var seen = {};
      var loading = false;

      function add(el) {
        var id = el.getAttribute('data-id');
        if (seen[id]) return false;
        seen[id] = true;
        var name = norm(el.getAttribute('data-name'));
        items.push({
          el: el,
          type: el.getAttribute('data-type') || '',
          letter: (name.match(/[a-z]/) || [''])[0],
          text: name + ' ' + norm(el.getAttribute('data-botanical'))
        });
        return true;
      }

      function valid(key, value) {
        for (var i = 0; i < buttons.length; i++) {
          if (
            buttons[i].getAttribute('data-xf-filter') === key &&
            buttons[i].getAttribute('data-value') === value
          ) return true;
        }
        return false;
      }

      function readHash() {
        var params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        var range = (params.get('range') || '').toUpperCase();
        var type = params.get('type') || '';
        state.range = valid('range', range) ? range : '';
        state.type = valid('type', type) ? type : '';
        state.q = searchEl ? params.get('q') || '' : '';
        if (searchEl && searchEl.value !== state.q) searchEl.value = state.q;
      }

      function writeHash() {
        var params = new URLSearchParams();
        if (state.range) params.set('range', state.range);
        if (state.type) params.set('type', state.type);
        if (state.q.trim()) params.set('q', state.q.trim());
        var hash = params.toString();
        var url = window.location.pathname + window.location.search + (hash ? '#' + hash : '');
        window.history.replaceState(window.history.state, '', url);
      }

      function apply() {
        var range = parseRange(state.range);
        var terms = norm(state.q).split(/\s+/).filter(Boolean);
        var shown = 0;

        items.forEach(function (item) {
          var ok =
            (!state.type || item.type === state.type) &&
            (!range || (item.letter >= range[0] && item.letter <= range[1])) &&
            terms.every(function (term) { return item.text.indexOf(term) !== -1; });
          item.el.hidden = !ok;
          if (ok) shown++;
        });

        for (var i = 0; i < buttons.length; i++) {
          var key = buttons[i].getAttribute('data-xf-filter');
          var pressed = buttons[i].getAttribute('data-value') === state[key];
          buttons[i].setAttribute('aria-pressed', pressed ? 'true' : 'false');
        }

        if (countEl) {
          countEl.textContent = loading
            ? 'Loading ' + label + '…'
            : shown === items.length
              ? items.length + ' ' + label
              : shown + ' of ' + items.length + ' ' + label;
        }
        if (emptyEl) emptyEl.hidden = loading || shown > 0;
      }

      function set(key, value) {
        state[key] = value;
        writeHash();
        apply();
      }

      // Collections over 250 products: pull the remaining pages in order
      function loadRest() {
        var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
        var current = parseInt(root.getAttribute('data-page'), 10) || 1;
        var param = root.getAttribute('data-page-param') || 'page';
        var sectionId = root.getAttribute('data-section-id');
        if (pages < 2 || !sectionId || !window.fetch) return;

        var queue = [];
        for (var n = 1; n <= pages; n++) if (n !== current) queue.push(n);

        loading = true;
        apply();

        queue
          .reduce(function (chain, n) {
            return chain.then(function () {
              var url = new URL(window.location.href);
              url.hash = '';
              url.searchParams.set(param, n);
              url.searchParams.set('section_id', sectionId);
              return fetch(url.toString(), { credentials: 'same-origin' })
                .then(function (res) {
                  if (!res.ok) throw new Error('HTTP ' + res.status);
                  return res.text();
                })
                .then(function (html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  doc.querySelectorAll('[data-xf-item]').forEach(function (el) {
                    var node = document.importNode(el, true);
                    if (add(node)) list.appendChild(node);
                  });
                });
            });
          }, Promise.resolve())
          .catch(function (err) {
            if (window.console) console.warn('Extract filter: could not load every page', err);
          })
          .then(function () {
            loading = false;
            apply();
          });
      }

      root.querySelectorAll('[data-xf-item]').forEach(add);

      root.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-xf-filter], [data-xf-clear]');
        if (!btn || !root.contains(btn)) return;
        if (btn.hasAttribute('data-xf-clear')) {
          state.range = '';
          state.type = '';
          state.q = '';
          if (searchEl) searchEl.value = '';
          writeHash();
          apply();
          return;
        }
        set(btn.getAttribute('data-xf-filter'), btn.getAttribute('data-value'));
      });

      if (searchEl) {
        searchEl.addEventListener('input', function () {
          set('q', searchEl.value);
        });
      }

      window.addEventListener('hashchange', function () {
        if (!document.body.contains(root)) return;
        readHash();
        apply();
      });

      readHash();
      apply();
      loadRest();
    }

    function initAll() {
      document.querySelectorAll('[data-xf]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Theme editor re-renders sections without a page load
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
